module.exports = __webpack_public_path__ + "static/media/ExerciseIconAddExam.a9029359.svg";